module.exports = __webpack_public_path__ + "img/20230104-0331eco_set_headder.9a06bbd0.jpg";